import SHIPROCKET_LOGO from "../../assets/shiprocketLogo.webp";

const DEFAULT_PICKUP_PINCODE = "201301";

const DELIVERY_STATUS = {
    PACKAGING: "PACKAGING",
    PACKED: "PACKED",
    READY_TO_SHIP: "READY_TO_SHIP",
    IN_TRANSIT: "IN_TRANSIT",
    OUT_FOR_DELIVERY: "OUT_FOR_DELIVERY",
    DELIVERED: "DELIVERED",
    CANCELLED: "CANCELLED",
    RETURN: "RETURN",
    ERROR: "ERROR",
};

const DELIVERY_TABS = {
    NEW: "new",
    DELIVERED: "delivered",
    CANCELLED: "cancelled",
    ERROR: "error",
};

const DELIVERY_TAB_STATUS_FILTER = {
    [DELIVERY_TABS.NEW]: [
        DELIVERY_STATUS.PACKAGING,
        DELIVERY_STATUS.PACKED,
        DELIVERY_STATUS.READY_TO_SHIP,
        DELIVERY_STATUS.IN_TRANSIT,
        DELIVERY_STATUS.OUT_FOR_DELIVERY,
        DELIVERY_STATUS.RETURN,
    ].join(","),
    [DELIVERY_TABS.DELIVERED]: DELIVERY_STATUS.DELIVERED,
    [DELIVERY_TABS.CANCELLED]: DELIVERY_STATUS.CANCELLED,
    [DELIVERY_TABS.ERROR]: DELIVERY_STATUS.ERROR,
};

const SELF_DELIVERY_EXECUTIVES = [
    { name: "Saurabh Sharma", phone: "9015682823" },
    { name: "Manmohan", phone: "9457239969" },
    { name: "Manoj", phone: "9971599320" },
    { name: "Mukesh Kumar", phone: "7011417217" },
];

const DELIVERY_PARTNER_IDS_MAP = {
    SHIPROCKET: 1,
    DTDC: 2,
    SHREEMARUTI: 3,
    DELHIVERY: 4,
    TRACKON: 5,
    EKART: 6,
    BLUEDART: 7,
    EXPRESSBEES: 8,
    INDIAPOST: 9,
    SELF: 10,
    ZYDUS: 11,
}

// Manual-delivery partners that never carry an external AWB/tracking link (in-house style
// delivery) — reference/tracking fields are neither required nor collected for these.
const NO_TRACKING_REQUIRED_PARTNER_IDS = [
    DELIVERY_PARTNER_IDS_MAP.SELF,
    DELIVERY_PARTNER_IDS_MAP.ZYDUS,
]

const SHIPROCKET_DELIVERY_STEPS = {
    "DELIVERY_DETAILS": "delivery-details",
    "SELECT_COURIER": "select-courier",
}

const DTDC_DELIVERY_STEPS = {
    "DELIVERY_DETAILS": "delivery-details",
    "SELECT_COURIER": "select-courier",
}

const DTDC_SERVICE_TYPES = {
    "B2CPriority": "B2C PRIORITY",
    "B2CSmartExpress": "B2C SMART EXPRESS",
}

const DEFAULT_PACKAGE_BOXES = {
    RECTANGULAR_BOX: {
        name: "rectangular-box",
        length: 25,
        breadth: 18,
        height: 10,
        weight: 0.9,
    },
    SQUARE_BOX: {
        name: "square-box",
        length: 18,
        breadth: 18,
        height: 10,
        weight: 0.648,
    },
    SMALL_BOX: {
        name: "small-box",
        length: 15,
        breadth: 15,
        height: 10,
        weight: 0.45,
    },
}

const DELIVERY_PARTNERS = {
    DTDC: {
        partnerName: "DTDC",
        partnerLogo: SHIPROCKET_LOGO,
        partnerId: DELIVERY_PARTNER_IDS_MAP.DTDC,
    },
    SHIPROCKET: {
        partnerName: "shiprocket",
        partnerLogo: SHIPROCKET_LOGO,
        partnerId: DELIVERY_PARTNER_IDS_MAP.SHIPROCKET,
    },
}

export {
    DELIVERY_PARTNERS,
    DELIVERY_STATUS,
    DELIVERY_TABS,
    DELIVERY_TAB_STATUS_FILTER,
    SELF_DELIVERY_EXECUTIVES,
    DEFAULT_PACKAGE_BOXES,
    SHIPROCKET_DELIVERY_STEPS,
    DELIVERY_PARTNER_IDS_MAP,
    DEFAULT_PICKUP_PINCODE,
    DTDC_DELIVERY_STEPS,
    DTDC_SERVICE_TYPES,
    NO_TRACKING_REQUIRED_PARTNER_IDS
}